import { render, staticRenderFns } from "./PenaltySectionView.vue?vue&type=template&id=71122935&scoped=true&"
import script from "./PenaltySectionView.vue?vue&type=script&lang=js&"
export * from "./PenaltySectionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71122935",
  null
  
)

export default component.exports